import React, { useMemo } from "react";
import styles from "../../assets/styles/Prospect/Prospect.module.scss";
import {
  AppPage,
  MimaButton,
  MimaOptionMenu,
  MimaTable,
} from "../../components";
import moment from "moment";
import constant from "../../utils/constant";
import { AnimatePresence } from "framer-motion";
import {
  AddBulkProspectContainer,
  AddProspectContainer,
} from "../../containers";

const Prospects = ({
  onLimitChange,
  data,
  currentPage,
  setCurrentPage,
  limit,
  isLoading,
  isFetching,
  setSearchQuery,
  addProspectModal,
  goToAddProspect,
  closeModal,
  goToAddBulkProspect,
  addBulkProspectModal,
}) => {
  const tableData = useMemo(() => {
    if (data?.status === constant.Success) {
      const prospects = data?.data?.prospects || [];

      return prospects;
    }
    return [];
  }, [data]);

  const tableColumns = [
    {
      Header: "Date Created",
      accessor: "createdAt",
      Cell: ({ cell }) => {
        const date = cell.row.original.createdAt;
        return <span>{moment(date).format("DD/MM/YYYY")}</span>;
      },
    },
    {
      Header: "Name",
      accessor: "fullname",
    },
    {
      Header: "Email",
      accessor: "email",
    },
    {
      Header: "Mobile",
      accessor: "mobile",
    },
    {
      Header: "Tag",
      accessor: "tag",
    },
    {
      Header: "Note",
      accessor: `description`,
    },
  ];
  return (
    <AppPage pageTitle="Prospects">
      <div className={styles.checks}>
        <MimaButton
          title="Add Prospect"
          mt={3}
          mb={3}
          onClick={goToAddProspect}
        />
        <MimaButton
          title="Add Bulk Prospects"
          mt={3}
          mb={3}
          onClick={goToAddBulkProspect}
        />
      </div>
      <MimaTable
        tableData={tableData}
        tableColumns={tableColumns}
        searchPlaceholder="Search Prospects"
        searchVariant="wide"
        totalItems={data?.data?.totalCounts}
        onLimitChange={onLimitChange}
        isLoading={isLoading}
        isFetching={isFetching}
        limit={limit}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setSearchQuery={setSearchQuery}
      />

      {(addProspectModal || addBulkProspectModal) && (
        <div className="modal">
          <AnimatePresence>
            {addProspectModal && (
              <AddProspectContainer closeModal={closeModal} />
            )}
            {addBulkProspectModal && (
              <AddBulkProspectContainer closeModal={closeModal} />
            )}
          </AnimatePresence>
        </div>
      )}
    </AppPage>
  );
};

export default Prospects;
